import type { TranslationFunction } from '@/app/components/translations/Translation';

export const rankingCriteriaCopy = (t: TranslationFunction) => {
  const [lead, link = '', tail = ''] = t('vacation.oss.indexcollapsed.ranking').split(/__(.*?)__/);

  return { lead: lead.trim(), link, tail: tail.trim() };
};
